import { Card, CardContent, Container, Divider, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { UtilsDate } from '../../../app/orussystem/utils/UtilDate';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';
import WcIcon from '@material-ui/icons/Wc';
import HeightIcon from '@material-ui/icons/Height';
import DateRangeIcon from '@material-ui/icons/DateRange';
import ScheduleIcon from '@material-ui/icons/Schedule';
import FingerprintIcon from '@material-ui/icons/Fingerprint';
const useStyles = makeStyles((theme) => ({
    root: {
        display: '1 0 auto',
        borderRadius: '18px',
        background: process.env.REACT_APP_PRIMARY_THEM,

    },
    details: {
        display: 'flex',
        flexDirection: 'column',

    },
    content: {
        flex: 'auto',
        background: '#ffffff',
        display: 'flex',

    },
    cover: {
        width: 151,
    },
    controls: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    playIcon: {
        height: 38,
        width: 38,
    },
}));


export default function ChartDatos({ data, genero }) {

    const classes = useStyles();
    //FUNCION PARA CONVERTIR LA EDAD
    const getAge = (birthday) => {
        const today = new Date();
        const birthDate = new Date(birthday);
        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    };
    const age = getAge(data[0]?.edad);

    return (
        <>

            <Card className={classes.root} >
                <div className={classes.details} >
                    <Container style={{ marginLeft: '15px', backgroundColor: '#ffffff' }}>
                        <CardContent className={classes.content} >
                            <Grid>
                                <Typography variant="subtitle1" color="textSecondary">
                                    <FingerprintIcon color='primary' />
                                </Typography>
                                <Typography component="h6" variant="h6">
                                    Número de cédula
                                </Typography>
                                <Typography variant="subtitle1" color="textSecondary">
                                    {data[0]?.numerodocumento ? data[0].numerodocumento : "--"}
                                </Typography>
                            </Grid>
                            <Divider style={{ marginLeft: '1%', background: '#D9D9D9' }} orientation="vertical" flexItem />
                            <Grid style={{ marginLeft: '15px' }}>
                                <Typography variant="subtitle1" color="textSecondary">
                                    <AccountCircleIcon color='primary' />
                                </Typography>
                                <Typography component="h6" variant="h6">
                                    Nombre
                                </Typography>
                                <Typography variant="subtitle1" color="textSecondary">
                                    {data[0]?.firstname ? data[0].firstname : "--"}
                                </Typography>
                            </Grid>

                            <Divider style={{ marginLeft: '1%', background: '#D9D9D9' }} orientation="vertical" flexItem />

                            <Grid style={{ marginLeft: '15px' }}>
                                <Typography variant="subtitle1" color="textSecondary">
                                    <PhoneAndroidIcon color='primary' />
                                </Typography>
                                <Typography component="h6" variant="h6" >
                                    Celular
                                </Typography>
                                <Typography variant="subtitle1" color="textSecondary">
                                    {data[0]?.celular ? data[0].celular : "--"}
                                </Typography>
                            </Grid>

                            <Divider style={{ marginLeft: '1%', background: '#D9D9D9' }} orientation="vertical" flexItem />

                            <Grid style={{ marginLeft: '15px' }}>
                                <Typography variant="subtitle1" color="textSecondary">
                                    <WcIcon color='primary' />
                                </Typography>
                                <Typography component="h6" variant="h6" >
                                    Género
                                </Typography>
                                <Typography variant="subtitle1" color="textSecondary">
                                    {genero === "M" ? 'Masculino' : (genero === "F" ? 'Femenino' : '--')}

                                </Typography>
                            </Grid>

                            <Divider style={{ marginLeft: '1%', background: '#D9D9D9' }} orientation="vertical" flexItem />

                            <Grid style={{ marginLeft: '15px' }}>
                                <Typography variant="subtitle1" color="textSecondary">
                                    <HeightIcon color='primary' />
                                </Typography>
                                <Typography component="h6" variant="h6" >
                                    Altura
                                </Typography>
                                <Typography variant="subtitle1" color="textSecondary">
                                    {data[0]?.altura ? data[0]?.altura : '--'}
                                </Typography>
                            </Grid>

                            <Divider style={{ marginLeft: '1%', background: '#D9D9D9' }} orientation="vertical" flexItem />

                            <Grid style={{ marginLeft: '15px' }}>
                                <Typography variant="subtitle1" color="textSecondary">
                                    <DateRangeIcon color='primary' />
                                </Typography>
                                <Typography component="h6" variant="h6" >
                                    Edad
                                </Typography>
                                <Typography variant="subtitle1" color="textSecondary">
                                    {age ? age : '--'}
                                </Typography>
                            </Grid>

                            <Divider style={{ marginLeft: '1%', background: '#D9D9D9' }} orientation="vertical" flexItem />

                            <Grid style={{ marginLeft: '15px' }}>
                                <Typography variant="subtitle1" color="textSecondary">
                                    <ScheduleIcon color='primary' />
                                </Typography>
                                <Typography component="h6" variant="h6" >
                                    Última medición
                                </Typography>
                                <Typography variant="subtitle1" color="textSecondary">
                                    {data[0]?.dateupdate ? UtilsDate().formatDDMMMYYYYHHmm(new Date(data[0]?.dateupdate)) : "--"}
                                </Typography>
                            </Grid>
                        </CardContent>
                    </Container>
                </div>

            </Card>

        </>
    );
}


